import SynthesisREC1 from '../../../page/synthesis/synthesisREC1' //padge
import SynthesisREC2 from '../../../page/synthesis/synthesisREC2' //padge
import AdditionalDocumentREC1 from '../../../page/additionalDocument/additionalDocumentREC1'
import AdditionalDocumentREC2 from '../../../page/additionalDocument/additionalDocumentREC2'
import VerifyDocumentREC1 from '../../../page/verifyDocument/verifyDocumentREC1'
import VerifyDocumentREC2 from '../../../page/verifyDocument/verifyDocumentREC2'
import DefineProjectREC1 from '../../../page/defineProject/defineProjectREC1'
import DefineProjectREC2 from '../../../page/defineProject/defineProjectREC2'
import GenerateCertificateREC1 from '../../../page/generateCertificate/generateCertificateREC1'
import GenerateCertificateREC2 from '../../../page/generateCertificate/generateCertificateREC2'
import DefineSubmittedDateREC1 from '../../../page/defineSubmittedDate/defineSubmittedDateREC1'
import DefineSubmittedDateREC2 from '../../../page/defineSubmittedDate/defineSubmittedDateREC2'
import ReviewerCommentREC1 from '../../../page/reviewerComment/reviewerCommentREC1'
import ReviewerCommentREC2 from '../../../page/reviewerComment/reviewerCommentREC2'

import SynthesisReviewREC1 from '../../../page/synthesisReview/synthesisReviewREC1'
import SynthesisReviewREC2 from '../../../page/synthesisReview/synthesisReviewREC2'
import ResultOfConsiderPrevious from '../../../page/resultOfConsiderPrevious/resultOfConsiderPrevious'

import SignREC1 from '../../../page/sign/signREC1'
import SignREC2 from '../../../page/sign/signREC2'
import SignRepresentREC2 from '../../../page/signRepresent/signRepresentREC2'
import SignRepresentREC1 from '../../../page/signRepresent/signRepresentREC1'

import { OfficerType, OfficerViewType } from './officerType'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useOfficer from './useOfficer'
import * as Constants from '../../../../../../constants/constants'

import SignVicePresidentREC2 from '../../../page/signVicePresident/signVicePresidentREC2'
import SignVicePresidentREC1 from '../../../page/signVicePresident/signVicePresidentREC1'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import constSubmittedStep from '../../../../../../constants/submittedStep'

const OfficerView: React.FC<OfficerViewType> = (props) => {
    const { callbackSaveComplete, projectData } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const checkPermission = useCheckPermission()

    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        const REC = manageProjectStore?.projectData?.irbType
        let isNotDisableTestResult = false
        switch (REC) {
            case 1:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1 <div> ตรวจสอบเอกสาร REC1</div>
                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC1
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC1</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC1
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        // code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return <ReviewerCommentREC1 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />

                    case Constants.menuTab.tab6.id:
                        // code block
                        return <SynthesisREC1 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />
                    case Constants.menuTab.tab7.id:
                        // code block
                        return <SynthesisReviewREC1 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab8.id:
                        // code block
                        return <GenerateCertificateREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block
                        return <SignREC1 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block
                        // return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
                        return renderSignRepresentElement(1)

                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={projectData?.projectID ?? 0}
                                submittedID={projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0}
                            />
                        )
                    default:
                        return <div></div>
                }

            case 2:
                switch (tabID) {
                    case Constants.menuTab.tab1.id:
                        // tab1
                        // return <div> ตรวจสอบเอกสาร REC2</div>

                        if (checkPermission.isUserChairman()) {
                            isNotDisableTestResult =
                                manageProjectStore?.projectData?.stepID === constSubmittedStep.specifyProjectType
                        }
                        return (
                            <VerifyDocumentREC2
                                projectData={manageProjectStore?.projectData ?? undefined}
                                onSaveComplete={callbackSaveComplete}
                                isNotDisableTestResult={isNotDisableTestResult}
                            />
                        )

                    case Constants.menuTab.tab2.id:
                        // code block
                        // return <div> กำหนดประเภทโครงการและกรรมการ REC2</div>
                        return (
                            (manageProjectStore?.projectData && (
                                <DefineProjectREC2
                                    projectData={manageProjectStore?.projectData}
                                    onSaveComplete={callbackSaveComplete}
                                />
                            )) || <></>
                        )
                    case Constants.menuTab.tab3.id:
                        /// code block กำหนดชุดโครงการที่ต้องส่ง
                        return <AdditionalDocumentREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab4.id:
                        // code blockชุดโครงการครบถ้วนและกำหนดส่งความคิดเห็นของผู้ทบทวนหลัก
                        return <DefineSubmittedDateREC2 callbackSaveComplete={callbackSaveComplete} />
                    case Constants.menuTab.tab5.id:
                        // code block บันทึกข้อคิดเห็นของกรรมการ
                        return <ReviewerCommentREC2 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />

                    case Constants.menuTab.tab6.id:
                        // code block
                        return <SynthesisREC2 callbackSaveComplete={callbackSaveComplete} isOneComment={true} />
                    case Constants.menuTab.tab7.id:
                        // code block
                        return <SynthesisReviewREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab8.id:
                        // code block
                        return <GenerateCertificateREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab9.id:
                        // code block
                        return <SignREC2 callbackSaveComplete={callbackSaveComplete} />

                    case Constants.menuTab.tab10.id:
                        // code block
                        // return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
                        return renderSignRepresentElement(2)

                    case Constants.menuTab.tab26.id:
                        return (
                            <ResultOfConsiderPrevious
                                projectID={projectData?.projectID ?? 0}
                                submittedID={projectData?.aroundSubmittedIDInfo.previousSubmittedID ?? 0}
                            />
                        )
                    default:
                        return <div></div>
                }

            default:
                return <div></div>
        }
    }
    const renderSignRepresentElement = (REC: 1 | 2) => {
        const isVicePresident = checkPermission.isUserViceChairman()
        if (REC === 1) {
            if (isVicePresident) {
                return <SignVicePresidentREC1 callbackSaveComplete={callbackSaveComplete} />
            } else {
                return <SignRepresentREC1 callbackSaveComplete={callbackSaveComplete} />
            }
        } else if (REC === 2) {
            if (isVicePresident) {
                return <SignVicePresidentREC2 callbackSaveComplete={callbackSaveComplete} />
            } else {
                return <SignRepresentREC2 callbackSaveComplete={callbackSaveComplete} />
            }
        }
    }

    return <> {renderPage()} </>
}

const Officer: React.FC<OfficerType> = (props) => {
    const useOfficerModel = useOfficer(props)
    return <OfficerView {...props} {...useOfficerModel} />
}
export default Officer
